import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=d487c11c&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d487c11c')) {
      api.createRecord('d487c11c', component.options)
    } else {
      api.reload('d487c11c', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=d487c11c&", function () {
      api.rerender('d487c11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fXoMIgTlwGWg/JS/comp/openstreetmap.vue"
export default component.exports